import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import moment from 'moment';

// Own constants/actions/components
import {
  deleteItemsShoppingCartAction,
  changeIsGiftAction,
  deleteItemToShoopingCartById,
  resetExp,
} from 'services/actions/shopping-cart';
import { getSessionAction } from 'services/actions/header';
import { getExclusivityBannerAction } from 'services/actions/exclusivity-banner';
import { experienciesExclusivitiesToRemoveAction, resetExclusivitiesAction } from 'services/actions/exclusivity-experience-remove.js';
import ExclusivitySantander from 'components/shopping-cart/exclusivity-santander';
import ExclusivityAmex from 'components/shopping-cart/exclusivity-amex';
import ModalExclusivity from 'components/modal-exclusivity-experience';
import ExclusivitiesAmexSantander from 'components/shopping-cart/exclusivities-amex-santander';
import LoaderCP from 'components/loader';

import { getExclusiveConflicts, hasExclusiveConflict } from 'helpers/exclusivity';
import ResumenTicket from './resumen-ticket';

const CardShopping = (props) => {
  const { items } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const excSantander = items.filter((exclusivity) => exclusivity.exclusivity === 'SANTANDER');
  const excAmex = items.filter((exclusivity) => exclusivity.exclusivity === 'AMEX');
  const excALL = items.filter((exclusivity) => exclusivity.exclusivity === 'ALL');
  const [show, setShow] = useState(excALL.length > 0);
  const [dataUser, setDataUser] = useState({});
  const [isFetching, setIsFetching] = useState(true);
  const cards = dataUser && dataUser.cards !== undefined ? dataUser.cards : [];
  const notcards = cards && cards.length === 0;
  const hasSantander = cards && cards.filter((type) => type === 'SANTANDER').length === 1;
  const hasAmex = cards && cards.filter((type) => type === 'AMEX').length === 1;

  const handleClose = () => setShow(false);

  const removeAutoExclusivity = (indexExpRemove) => {
    dispatch(deleteItemToShoopingCartById(indexExpRemove));
    dispatch(resetExclusivitiesAction());
  };

  const resetShoppingCart = () => {
    dispatch(resetExp());
    dispatch(resetExclusivitiesAction());
  };

  const handleGift = (event) => {
    dispatch(changeIsGiftAction(event.target.dataset.index, event.target.checked));
  };

  const randomInteger = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const deleteExperience = (event) => {
    event.preventDefault();
    const ind = event.target.dataset.index;
    dispatch(deleteItemsShoppingCartAction(ind));
  };

  const deleteExpiredExperiences = () => {
    const today = new Date().getTime();

    items.map((item) => {
      const experienceFormatDate = item.delivery.split('-');
      const experienceDate = new Date(
        experienceFormatDate[2], experienceFormatDate[1] - 1, experienceFormatDate[0],
      ).getTime();

      if (experienceDate < today) {
        dispatch(deleteItemToShoopingCartById(item.id));
      }

      return true;
    });
  };

  const renderBody = () => {
    return (
      items.map((item, index) => {
        const iden = randomInteger(1, 999);
        return (
          <div className="shopping-card-info mb-15" data-id={item.experienceId} key={iden}>
            <Row>
              <Col xs={12} lg={4}>
                <img
                  src={item.image}
                  alt="card-exp"
                  className="w-100 p-15" />
              </Col>
              <Col xs={12} lg={4} className="text-left text-dove-gray">
                <h3 className="p-15 text-tangaroa text-bold ft-16">{item.title}</h3>
                {
                  item.type === 'TRAVEL' || item.type === 'TRAVEL_INTERNATIONAL' ? (
                    <>
                      <i className="fas fa-calendar-alt icon p-15" />
                      {item.startDelivery ? <small className="text-dove-gray">{`Fecha de ida: ${item.startDelivery}`}</small> : ''}
                      <br />
                      <i className="fas fa-calendar-alt icon p-15" />
                      {item.endDelivery ? <small className="text-dove-gray">{`Fecha de regreso: ${item.endDelivery}`}</small> : ''}
                      <br />
                      { item.duration
                        ? (
                          <small className="text-dove-gray">
                            <i className="fas fa-clock icon p-15" />
                            {item.duration}
                          </small>
                        ) : '' }
                    </>
                  ) : ''
                }
                {
                  item.type === 'FACE_TO_FACE' || item.type === 'MASTERCLASS' ? (
                    <>
                      <i className="fas fa-calendar-alt icon p-15" />
                      {item.startDelivery ? <small className="text-dove-gray">{`Fecha de ida: ${moment(item.startDelivery).format('DD/MM/YYYY')}`}</small> : ''}
                      <br />
                      { item.duration
                        ? (
                          <small className="text-dove-gray">
                            <i className="fas fa-clock icon p-15" />
                            {item.duration}
                          </small>
                        ) : '' }
                    </>
                  ) : ''
                }
                {
                  item.type === 'HOUSE' ? (
                    <>
                      { item.delivery && item.delivery !== 'default'
                        ? (
                          <small className="text-dove-gray">
                            <i className="fas fa-calendar-alt icon p-15" />
                            {`Fecha de entrega: ${item.delivery}`}
                          </small>
                        ) : '' }
                      <br />
                      { item.duration
                        ? (
                          <small className="text-dove-gray">
                            <i className="fas fa-clock icon p-15" />
                            {item.duration}
                          </small>
                        ) : '' }
                    </>
                  ) : ''
                }
              </Col>
              <Col xs={12} lg={3}>
                <h2 className="text-center text-dark-blue p-15 ft-14">
                  {(Number(item.points)).toLocaleString('es-MX')}
                  <br />
                  Puntos Aeroméxico Rewards
                </h2>
                <i className="fas fa-gift icon-green mt-lg-30" />
                <div className="custom-control custom-checkbox checkbox-gift">
                  <input
                    id={`custom-check-${index}`}
                    data-index={index}
                    data-identificador={iden}
                    className="custom-control-input"
                    type="checkbox"
                    checked={item.isGift === true}
                    onChange={handleGift} />
                  <label htmlFor={`custom-check-${index}`} className="custom-control-label" data-identificador={iden}>
                    <p className="text-tangaroa">Es un regalo</p>
                  </label>
                </div>
              </Col>
              <Col xs={12} lg={1}>
                <div className="col-delete">
                  <a href="/" className="not-link" data-index={index} onClick={deleteExperience}>
                    <i className="fas fa-trash-alt" data-index={index} />
                  </a>
                </div>
              </Col>
              {
                item.isGift === true ? (
                  <Col lg={12}>
                    <div className="text-left gift-label">
                      <i className="fas fa-gift mr-2 text-white" />
                      <span>Esta Experiencia es un regalo</span>
                    </div>
                  </Col>
                ) : ''
              }
              {
                item.stock !== null && item.stock < 5 ? (
                  <Col lg={12}>
                    <div className="text-left stock-label text-tangaroa">
                      <i className="fas fa-exclamation-triangle mr-2" />
                      <span>Quedan muy pocas Experiencias. ¡Date prisa!</span>
                    </div>
                  </Col>
                ) : ''
              }
            </Row>
          </div>
        );
      })
    );
  };

  const renderDefault = (dataModal) => {
    return (
      <>
        {dataModal ? (
          <ModalExclusivity
            stateInitial={show}
            close={handleClose}
            itemsCart={dataModal}
            removeFunc={removeAutoExclusivity}
            path="mis-experiencias" />
        ) : '' }
        <Col lg={12} className="text-center">
          <h1 className="text-midnight-blue">Mis Experiencias</h1>
        </Col>
        <Col lg={9} className="text-center mt-30">
          { renderBody() }
          <Row className="py-60">
            <Col lg={12} className="text-right">
              <Link to="/" className="btn btn-secondary mr-15 mb-15">Regresar</Link>
              <Link to="/experiencias-payment" className="btn btn-primary mb-15">Continuar</Link>
            </Col>
          </Row>
        </Col>
        <Col lg={3}>
          <ResumenTicket resumen={items} />
        </Col>
      </>
    );
  };

  const allCasesExperiencies = () => {
    if (notcards) {
      /* Only if this cart has two differents exlusivities experiencies */
      if (excAmex.length && excSantander.length && excALL.length === 0) {
        return <ExclusivitiesAmexSantander resetShoppingCart={resetShoppingCart} />;
      }

      /* Only if this cart has one exlusivity experience */
      if (excSantander.length && excALL.length === 0) {
        dispatch(getExclusivityBannerAction('SANTANDER_EXCLUSIVITY'));
        return <ExclusivitySantander uui={excSantander[0].id} removeFunc={removeAutoExclusivity} />;
      }
      if (excAmex.length && excALL.length === 0) {
        dispatch(getExclusivityBannerAction('AMEX_EXCLUSIVITY'));
        return <ExclusivityAmex uui={excAmex[0].id} removeFunc={removeAutoExclusivity} />;
      }

      /* Only if this cart has one exlusivity experience and other not exlusivity */
      if (excSantander.length && excALL.length && excAmex.length === 0) {
        dispatch(experienciesExclusivitiesToRemoveAction(excSantander));
        return renderDefault(excSantander);
      }
      if (excAmex.length && excALL.length && excSantander.length === 0) {
        dispatch(experienciesExclusivitiesToRemoveAction(excAmex));
        return renderDefault(excAmex);
      }

      /* Only if this cart has two differents exlusivities and other not exlusivities */
      if (excAmex.length && excSantander.length && excALL.length) {
        const combineArray = excAmex.concat(excSantander);
        dispatch(experienciesExclusivitiesToRemoveAction(combineArray));
        return renderDefault(combineArray);
      }
    }

    if (hasAmex && hasSantander) {
      const otherConflicts = getExclusiveConflicts(items, cards);
      if (otherConflicts.length) {
        dispatch(experienciesExclusivitiesToRemoveAction(otherConflicts));
        return renderDefault(otherConflicts);
      }
      return renderDefault();
    }

    if (hasSantander) {
      /* Only if this cart has one exlusivity experience */
      if (excAmex.length && excALL.length === 0) {
        dispatch(getExclusivityBannerAction('AMEX'));
        return <ExclusivityAmex />;
      }

      /* Only if this cart has one exlusivity experience and other not exlusivity */
      if (excAmex.length && excALL.length) {
        dispatch(experienciesExclusivitiesToRemoveAction(excAmex));
        return renderDefault(excAmex);
      }
    }

    if (hasAmex) {
      /* Only if this cart has one exlusivity experience */
      if (excSantander.length && excALL.length === 0) {
        dispatch(getExclusivityBannerAction('SANTANDER'));
        return <ExclusivitySantander />;
      }

      /* Only if this cart has one exlusivity experience and other not exlusivity */
      if (excSantander.length && excALL.length) {
        dispatch(experienciesExclusivitiesToRemoveAction(excSantander));
        return renderDefault(excSantander);
      }
    }

    /* Safety net for any exclusivity not covered above (e.g. a new co-brand) or a
       card that doesn't match the experience's required exclusivity */
    const exclusiveConflicts = getExclusiveConflicts(items, cards);
    if (exclusiveConflicts.length) {
      dispatch(experienciesExclusivitiesToRemoveAction(exclusiveConflicts));
      return renderDefault(exclusiveConflicts);
    }

    return renderDefault();
  };

  useEffect(async () => {
    const response = await dispatch(getSessionAction());
    const {
      action: {
        payload: {
          data,
        },
      },
    } = response;

    setDataUser(data);
    setIsFetching(false);

    const fetchedCards = data && data.cards !== undefined ? data.cards : [];

    if (hasExclusiveConflict(items, fetchedCards)) {
      setShow(true);
    }

    const arrayPoints = [];
    items.map((item) => {
      return arrayPoints.push(Number(item.points));
    });
    const sum = arrayPoints.reduce((prev, curr) => prev + curr, 0);

    if (!hasExclusiveConflict(items, fetchedCards) && data.points < sum) {
      resetShoppingCart();
      history.push('/insufficient-points');
    }

    deleteExpiredExperiences();
  }, []);

  return (
    <>
      { isFetching ? <LoaderCP /> : allCasesExperiencies() }
    </>
  );
};

CardShopping.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    experienceId: PropTypes.number,
    title: PropTypes.string,
    image: PropTypes.string,
    points: PropTypes.number,
    delivery: PropTypes.string,
    startDelivery: PropTypes.string,
    endDelivery: PropTypes.string,
    duration: PropTypes.string,
    selectedMenuId: PropTypes.string,
  })).isRequired,
};

export default CardShopping;
